import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { updateSuperLollipopLastSeen } from './superLollipop.modifiers';

export const superLollipopActions = createActions({
  /**
   * Update the last seen timestamp of the Super Lollipop feature
   */
  updateSuperLollipopLastSeen: action((state, _, api) => {
    // Update the last seen timestamp
    updateSuperLollipopLastSeen(state, api.date.now());
  }),
});
